import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import {useHistory,useLocation} from 'react-router-dom'
import axios from "axios";
import BaseUrl from "../BaseUrl";
export default function CreateAccount(props){
    // const { id } = props.match.params;
    const locData = useLocation();
    console.log('hfdjfkfkfkfkf',locData.search)
    const history = useHistory();
    useEffect(() => {
        const match = locData.search.match(/[?&]code=([^&]*)/);
    let accData={
        code :match[1]
    }
      axios
        .post(`${BaseUrl.baseurl}/email-marketing/user-from-email/get-google-refresh-token`,accData)
        .then((res) => {
          if (res.data) {
            console.log("mmrm",res.data)
            //   localStorage.setItem("MailSenderuserDetails",JSON.stringify(res.data))
             
            //   history.push('/DashBoard/Campaign')
          }
          else
          {
            // setStatus(false)
          }
        })
        .catch((err) => console.log("Error"));
    }, []);
    return(
        <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
     <CircularProgress
      size={50}
      style={{
        color: "#1C485F",
      }}
    />
      
    </div>
    )
}